import $ from 'jquery';
import 'jquery-colorbox';


export default (function () {


    var defaultWidth = "500px";
    var defaultMaxWidth = "95%";
    var defaultHeight = "auto";
    var defaultOpacity = 0.5;

    var renderJavascriptElement = function (element) {
        renderPopup($(element));
    };


    var renderPopup = function ($html) {
        $.colorbox({ inline: true, href: $html, width: defaultWidth, maxWidth: defaultMaxWidth, height: defaultHeight, opacity: defaultOpacity });
    };

    var init = function () {
        $("body").on('click', ".js-close-popup", onClosePopupClick);
    };

    var onClosePopupClick = function (event) {
        event.preventDefault();
        closeAllPopups();
    };


    var closeAllPopups = function () {
        parent.$.colorbox.close();
    };


    var renderErrorMessage = function (message) {
        renderMessage(message, "error");
    };

    var renderSuccessMessage = function (message) {
        renderMessage(message, "success");
    };

    var renderMessage = function (message, cssClass) {
        var $div = $("<div></div>");
        var $message = $("<p>" + message + "</p>").addClass(cssClass);
        var $okButton = $("<button type=\"button\">Ok</button>")
            .addClass("js-close-popup")
            .addClass("btn");

        $div.append($message)
            .append($okButton);
        renderPopup($div);
    };



    var renderElementOnPageBySelector = function (selector, onCompleteCallback) {
        $.colorbox({
            inline: true,
            href: selector,
            width: defaultWidth,
            maxWidth: defaultMaxWidth,
            height: defaultHeight,
            onComplete: onCompleteCallback,        
            opacity: defaultOpacity
        });
    }; 

    return {
        renderPopup: renderPopup,
        closeAllPopups: closeAllPopups,
        init: init,
        renderErrorMessage: renderErrorMessage,
        renderSuccessMessage: renderSuccessMessage,
        renderElementOnPageBySelector: renderElementOnPageBySelector,
        renderJavascriptElement: renderJavascriptElement
    };


})();


